// src/components/admin/AdminLayout.js
import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Box } from "@mui/material";
import AdminSidebar from "./AdminSidebar";
import AdminNavbar from "./AdminNavbar";
import { themeColors } from "../../theme/colors";

const drawerWidth = 260;
const collapsedWidth = 70;

const AdminLayout = () => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [desktopOpen, setDesktopOpen] = useState(true);

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const handleDesktopToggle = () => {
    setDesktopOpen(!desktopOpen);
  };

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        backgroundColor: themeColors.background.default,
        position: "relative",
      }}
    >
      <AdminSidebar
        mobileOpen={mobileOpen}
        handleDrawerToggle={handleDrawerToggle}
        desktopOpen={desktopOpen}
        handleDesktopToggle={handleDesktopToggle}
        drawerWidth={drawerWidth}
        collapsedWidth={collapsedWidth}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: "100%",
          minHeight: "100vh",
          transition: "margin 0.3s cubic-bezier(0.4, 0, 0.2, 1)",
          marginRight: {
            xs: 0,
            md: desktopOpen ? `${drawerWidth}px` : `${collapsedWidth}px`,
          },
          display: "flex",
          flexDirection: "column",
        }}
      >
        <AdminNavbar
          handleDrawerToggle={handleDrawerToggle}
          handleDesktopToggle={handleDesktopToggle}
          desktopOpen={desktopOpen}
          drawerWidth={drawerWidth}
          collapsedWidth={collapsedWidth}
        />

        <Box
          sx={{
            padding: { xs: "16px", sm: "20px", md: "24px" },
            marginTop: "64px",
            maxWidth: "1800px",
            width: "100%",
            mx: "auto",
            flex: 1,
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default AdminLayout;
